import apiClient from './apiClient';

export async function runOptimization(days = 14) {
  const res = await apiClient.get('/optimization', { params: { days } });
  return res.data.data;
}
